import {
    allFetch
} from "../Domain";

/**
 * @description 營銷活動計畫
 */
export const MarketingActivity = (() => {
    /**
     * @description 查詢報表
     */
    const MarketingActivitySearch = async function (obj = {
        position_ids: [],
        report_name: '',
        report_month: '',
        release: '',
        seal: '',
        page: '',
        num_per_page: ''
    }) {
        return await allFetch('MarketingActivity/MarketingActivitySearch', obj);
    }

    /**
     * @description 報表產生
     */
    const MarketingActivityTableCreate = async function (obj = {
        position_id: '',
        start_month: '',
        end_month: '',
        start_date: '',
        end_date: '',
        target_deal_count: ''
    }) {
        return await allFetch('MarketingActivity/MarketingActivityTableCreate', obj);
    }

    /**
     * @description 報表新建
     */
    const MarketingActivityCreate = async function (obj = {
        position_id: '',
        SA: '',
        report_name: '',
        report_JSON: '',
        start_month: '',
        end_month: '',
        report_month: ''
    }) {
        return await allFetch('MarketingActivity/MarketingActivityCreate', obj);
    }

    /**
     * @description 報表刪除
     */
    const MarketingActivityDelete = async function (obj = {
        report_id: ''
    }) {
        return await allFetch('MarketingActivity/MarketingActivityDelete', obj);
    }

    /**
     * @description 報表細項
     */
    const MarketingActivityDetail = async function (obj = {
        report_id: ''
    }) {
        return await allFetch('MarketingActivity/MarketingActivityDetail', obj);
    }

    /**
     * @description 報表計算
    */
    const CalculateMarketingActivity = async function (obj = {
        list: new Array(),
        this_month_work_day: '',
        until_now_work_day: '',
        relative_target_complete_rate: ''
    }) {
        return await allFetch('MarketingActivity/CalculateMarketingActivity', obj);
    }

    /**
     * @description 報表修改
    */
    const MarketingActivityUpdate = async function (obj = {
        report_id: '',
        position_id: '',
        SA: '',
        report_name: '',
        report_JSON: '',
        start_month: '',
        end_month: '',
        report_month: ''
    }) {
        return await allFetch('MarketingActivity/MarketingActivityUpdate', obj);
    }

    /**
     * @description 報表發布 & 取消
     */
    const MarketingActivityRelease = async function (obj = {
        report_id: '',
        release: ''
    }) {
        return await allFetch('MarketingActivity/MarketingActivityRelease', obj);
    }

    /**
     * @description 報表封存
     */
    const MarketingActivitySeal = async function (obj = {
        report_id: ''
    }) {
        return await allFetch('MarketingActivity/MarketingActivitySeal', obj);
    }

    /**
     * @description 查詢即時統計數字
     */
    const MarketingActivityGetDatePC = async function (obj = {
        position_id: '',
        start_date: '',
        end_date: ''
    }) {
        return await allFetch('MarketingActivity/MarketingActivityGetDatePC', obj);
    }


    return {
        MarketingActivitySearch,
        MarketingActivityTableCreate,
        MarketingActivityCreate,
        MarketingActivityDelete,
        MarketingActivityDetail,
        CalculateMarketingActivity,
        MarketingActivityUpdate,
        MarketingActivityRelease,
        MarketingActivitySeal,
        MarketingActivityGetDatePC
    }
})();
